import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/mobile/page.tsx");
